import { DepositSettlement } from "modules/term-loan/DepositSettlement";
import React from "react";

const TermDepositSettlement: React.FC = () => {
  return <DepositSettlement />;
};

export default TermDepositSettlement;
